import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const USER_ENDPOINT = {
  UPLOAD_PROFILE_PICTURE: {
    method: EMethod.POST,
    url: "/user/profile-picture",
    version: API_VERSION.V1,
  },
  LOGIN: {
    method: EMethod.POST,
    url: "/user/login",
    version: API_VERSION.V1,
  },
  GET_REFRESH_TOKEN: {
    method: EMethod.PATCH,
    url: "/user/refresh-token",
    version: API_VERSION.V1,
  },
  GET_USER: {
    method: EMethod.GET,
    url: "/user",
    version: API_VERSION.V1,
  },
  UPDATE_CORPORATION_SEQUENCE: {
    method: EMethod.POST,
    url: "/user/sequence/corp",
    version: API_VERSION.V1,
  },
  UPDATE_PROFILE_PICTURE: {
    method: EMethod.POST,
    url: "/user/profile-picture",
    version: API_VERSION.V1,
  },
  GET_COUNTRY: {
    method: EMethod.GET,
    url: "/user/country",
    version: API_VERSION.V1,
  },
  GET_BRANCH_LIST: {
    method: EMethod.GET,
    url: "/user/branch-office/list",
    version: API_VERSION.V1,
  },
  SEARCH_BRANCH_OFFICE: {
    method: EMethod.GET,
    url: "/user/branch-office/search",
    version: API_VERSION.V1,
  },
  ADD_ADDRESS: {
    method: EMethod.POST,
    url: "/user/address",
    version: API_VERSION.V1,
  },
  UPDATE_ADDRESS: {
    method: EMethod.PUT,
    url: "/user/address",
    version: API_VERSION.V1,
  },
  DELETE_ADDRESS: {
    method: EMethod.DEL,
    url: "/user/address",
    version: API_VERSION.V1,
  },
  SET_DEFAULT_AS_RESIDENCE: {
    method: EMethod.PUT,
    url: "/user/address/default-residence",
    version: API_VERSION.V1,
  },
  ADD_DEPARTMENT: {
    method: EMethod.POST,
    url: "/user/department",
    version: API_VERSION.V1,
  },
  GET_DEPARTMENT: {
    method: EMethod.GET,
    url: "/user/department/list",
    version: API_VERSION.V1,
  },
  SEARCH_DEPARTMENT: {
    method: EMethod.GET,
    url: "/user/department/search",
    version: API_VERSION.V1,
  },
  GET_USER_LIST: {
    method: EMethod.POST,
    url: "/user/list/{userType}",
    version: API_VERSION.V1,
  },
  // Staff
  CREATE_STAFF: {
    method: EMethod.POST,
    url: "/user/staff",
    version: API_VERSION.V1,
  },
  USER_STAFF_LIST: {
    method: EMethod.POST,
    url: "/user/list/staff",
    version: API_VERSION.V1,
  },
  GET_STAFF_SETTING: {
    method: EMethod.GET,
    url: "/user/staff/setting",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_SETTING: {
    method: EMethod.PUT,
    url: "/user/staff/setting",
    version: API_VERSION.V1,
  },
  GET_STAFF_BASIC_INFO: {
    method: EMethod.GET,
    url: "/user/staff/basic-information",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_BASIC_INFO: {
    method: EMethod.PATCH,
    url: "/user/staff/basic-information",
    version: API_VERSION.V1,
  },
  GET_STAFF_TRANSFER_DESTINATION: {
    method: EMethod.GET,
    url: "/user/staff/transfer-destination",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_TRANSFER_DESTINATION: {
    method: EMethod.PATCH,
    url: "/user/staff/transfer-destination",
    version: API_VERSION.V1,
  },
  GET_STAFF_RESIDENCE_CARD: {
    method: EMethod.GET,
    url: "/user/staff/residence-card",
    version: API_VERSION.V1,
  },
  ADD_STAFF_RESIDENCE_CARD: {
    method: EMethod.POST,
    url: "/user/staff/residence-card",
    version: API_VERSION.V1,
  },
  DELETE_STAFF_FILE: {
    method: EMethod.DEL,
    url: "/user/staff/file",
    version: API_VERSION.V1,
  },
  GET_STAFF_WORK_EXPERIENCES: {
    method: EMethod.GET,
    url: "/user/staff/work-experience",
    version: API_VERSION.V1,
  },
  CREATE_STAFF_WORK_EXPERIENCES: {
    method: EMethod.POST,
    url: "/user/staff/work-experience",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_WORK_EXPERIENCES: {
    method: EMethod.PUT,
    url: "/user/staff/work-experience",
    version: API_VERSION.V1,
  },
  DELETE_STAFF_WORK_EXPERIENCES: {
    method: EMethod.DEL,
    url: "/user/staff/work-experience",
    version: API_VERSION.V1,
  },
  GET_STAFF_APPLICATION_MEDIUM: {
    method: EMethod.GET,
    url: "/user/staff/application-medium",
    version: API_VERSION.V1,
  },
  GET_ALL_APPLICATION_MEDIUM: {
    method: EMethod.GET,
    url: "/user/staff/application-medium/list",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_APPLICATION_MEDIUM: {
    method: EMethod.PUT,
    url: "/user/staff/application-medium",
    version: API_VERSION.V1,
  },
  ADD_STAFF_ID_CARD: {
    method: EMethod.POST,
    url: "/user/staff/id-card",
    version: API_VERSION.V1,
  },
  GET_STAFF_ID_CARD: {
    method: EMethod.GET,
    url: "/user/staff/id-card",
    version: API_VERSION.V1,
  },
  ADD_STAFF_DRIVER_LICENCE: {
    method: EMethod.POST,
    url: "/user/staff/driver-license",
    version: API_VERSION.V1,
  },
  GET_STAFF_DRIVER_LICENCE: {
    method: EMethod.GET,
    url: "/user/staff/driver-license",
    version: API_VERSION.V1,
  },
  GET_STAFF_PARTICIPANT_INSURANCE: {
    method: EMethod.GET,
    url: "/user/staff/participant-insurance",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_PARTICIPANT_INSURANCE: {
    method: EMethod.PATCH,
    url: "/user/staff/participant-insurance",
    version: API_VERSION.V1,
  },
  GET_STAFF_ACADEMIC_QUALIFICATION: {
    method: EMethod.GET,
    url: "/user/staff/academic-qualification",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_ACADEMIC_QUALIFICATION: {
    method: EMethod.PATCH,
    url: "/user/staff/academic-qualification",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_HIGHEST_LEVEL_EDUCATION: {
    method: EMethod.PUT,
    url: "/user/staff/highest-level-education",
    version: API_VERSION.V1,
  },
  GET_STAFF_QUALIFICATIONS: {
    method: EMethod.GET,
    url: "/user/staff/qualification/search",
    version: API_VERSION.V1,
  },
  ADD_STAFF_QUALIFICATION: {
    method: EMethod.POST,
    url: "/user/staff/qualification",
    version: API_VERSION.V1,
  },
  ADD_STAFF_STUDENT_ID: {
    method: EMethod.POST,
    url: "/user/staff/id-student",
    version: API_VERSION.V1,
  },
  DELETE_STUDENT_ID: {
    method: EMethod.DEL,
    url: "/user/staff/id-student",
    version: API_VERSION.V1,
  },
  GET_STAFF_STUDENT_ID: {
    method: EMethod.GET,
    url: "/user/staff/id-student",
    version: API_VERSION.V1,
  },
  DELETE_STAFF: {
    method: EMethod.DEL,
    url: "/user/staff",
    version: API_VERSION.V1,
  },

  GET_STAFF_INSURANCE: {
    method: EMethod.POST,
    url: "/user/staff/participant-insurance/get",
    version: API_VERSION.V1,
  },
  ADD_STAFF_INSURANCE: {
    method: EMethod.POST,
    url: "/user/staff/participant-insurance",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_INSURANCE: {
    method: EMethod.PATCH,
    url: "/user/staff/participant-insurance",
    version: API_VERSION.V1,
  },
  DELETE_STAFF_INSURANCE: {
    method: EMethod.DEL,
    url: "/user/staff/participant-insurance",
    version: API_VERSION.V1,
  },
  GET_STAFF_MATERNITY_CHILDREN_LEAVE: {
    method: EMethod.GET,
    url: "/user/staff/maternity-children-leave",
    version: API_VERSION.V1,
  },
  ADD_STAFF_MATERNITY_CHILDREN_LEAVE: {
    method: EMethod.POST,
    url: "/user/staff/maternity-children-leave",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_MATERNITY_CHILDREN_LEAVE: {
    method: EMethod.PATCH,
    url: "/user/staff/maternity-children-leave",
    version: API_VERSION.V1,
  },
  DELETE_STAFF_MATERNITY_CHILDREN_LEAVE: {
    method: EMethod.DEL,
    url: "/user/staff/maternity-children-leave",
    version: API_VERSION.V1,
  },
  GET_STAFF_RETIREMENT_PAYMENT: {
    method: EMethod.GET,
    url: "/user/staff/retirement-payment",
    version: API_VERSION.V1,
  },
  ADD_STAFF_RETIREMENT_PAYMENT: {
    method: EMethod.POST,
    url: "/user/staff/retirement-payment",
    version: API_VERSION.V1,
  },
  UPDATE_STAFF_RETIREMENT_PAYMENT: {
    method: EMethod.PATCH,
    url: "/user/staff/retirement-payment",
    version: API_VERSION.V1,
  },

  //End of Staff

  // Employee
  GET_EMPLOYEE_BASIC_INFO: {
    method: EMethod.GET,
    url: "/user/employee/basic-information",
    version: API_VERSION.V1,
  },
  UPDATE_EMPLOYEE_BASIC_INFO: {
    method: EMethod.PATCH,
    url: "/user/employee/basic-information",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_SETTING: {
    method: EMethod.GET,
    url: "/user/employee/setting",
    version: API_VERSION.V1,
  },
  UPDATE_EMPLOYEE_SETTING: {
    method: EMethod.PUT,
    url: "/user/employee/setting",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_RESIDENCE_CARD: {
    method: EMethod.GET,
    url: "/user/employee/residence-card",
    version: API_VERSION.V1,
  },
  ADD_EMPLOYEE_RESIDENCE_CARD: {
    method: EMethod.POST,
    url: "/user/employee/residence-card",
    version: API_VERSION.V1,
  },
  DELETE_EMPLOYEE_FILE: {
    method: EMethod.DEL,
    url: "/user/employee/file",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_PARTICIPANT_INSURANCE: {
    method: EMethod.GET,
    url: "/user/employee/participant-insurance",
    version: API_VERSION.V1,
  },
  UPDATE_EMPLOYEE_PARTICIPANT_INSURANCE: {
    method: EMethod.PATCH,
    url: "/user/employee/participant-insurance",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_TRANSFER_DESTINATION: {
    method: EMethod.GET,
    url: "/user/employee/transfer-destination",
    version: API_VERSION.V1,
  },
  UPDATE_EMPLOYEE_TRANSFER_DESTINATION: {
    method: EMethod.PATCH,
    url: "/user/employee/transfer-destination",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_POST: {
    method: EMethod.GET,
    url: "/user/employee/post/list",
    version: API_VERSION.V1,
  },
  SEARCH_EMPLOYEE_POST: {
    method: EMethod.GET,
    url: "/user/employee/post/search",
    version: API_VERSION.V1,
  },
  SEARCH_CLIENT_POST: {
    method: EMethod.GET,
    url: "/user/client/post/search",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_ID_CARD: {
    method: EMethod.GET,
    url: "/user/employee/id-card",
    version: API_VERSION.V1,
  },
  ADD_EMPLOYEE_ID_CARD: {
    method: EMethod.POST,
    url: "/user/employee/id-card",
    version: API_VERSION.V1,
  },
  ADD_EMPLOYEE_DRIVER_LICENCE: {
    method: EMethod.POST,
    url: "/user/employee/driver-license",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_DRIVER_LICENCE: {
    method: EMethod.GET,
    url: "/user/employee/driver-license",
    version: API_VERSION.V1,
  },
  DELETE_EMPLOYEE: {
    method: EMethod.DEL,
    url: "/user/employee",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_INSURANCE: {
    method: EMethod.POST,
    url: "/user/employee/participant-insurance/get",
    version: API_VERSION.V1,
  },
  ADD_EMPLOYEE_INSURANCE: {
    method: EMethod.POST,
    url: "/user/employee/participant-insurance",
    version: API_VERSION.V1,
  },
  UPDATE_EMPLOYEE_INSURANCE: {
    method: EMethod.PATCH,
    url: "/user/employee/participant-insurance",
    version: API_VERSION.V1,
  },
  DELETE_EMPLOYEE_INSURANCE: {
    method: EMethod.DEL,
    url: "/user/employee/participant-insurance",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_RETIREMENT_PAYMENT: {
    method: EMethod.GET,
    url: "/user/employee/retirement-payment",
    version: API_VERSION.V1,
  },
  ADD_EMPLOYEE_RETIREMENT_PAYMENT: {
    method: EMethod.POST,
    url: "/user/employee/retirement-payment",
    version: API_VERSION.V1,
  },
  UPDATE_EMPLOYEE_RETIREMENT_PAYMENT: {
    method: EMethod.PATCH,
    url: "/user/employee/retirement-payment",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_MATERNITY_CHILDREN_LEAVE: {
    method: EMethod.GET,
    url: "/user/employee/maternity-children-leave",
    version: API_VERSION.V1,
  },
  ADD_EMPLOYEE_MATERNITY_CHILDREN_LEAVE: {
    method: EMethod.POST,
    url: "/user/employee/maternity-children-leave",
    version: API_VERSION.V1,
  },
  UPDATE_EMPLOYEE_MATERNITY_CHILDREN_LEAVE: {
    method: EMethod.PATCH,
    url: "/user/employee/maternity-children-leave",
    version: API_VERSION.V1,
  },
  DELETE_EMPLOYEE_MATERNITY_CHILDREN_LEAVE: {
    method: EMethod.DEL,
    url: "/user/employee/maternity-children-leave",
    version: API_VERSION.V1,
  },

  // client
  USER_CLIENT_LIST: {
    method: EMethod.POST,
    url: "/user/list/client",
    version: API_VERSION.V1,
  },
  USER_EMPLOYEE_LIST: {
    method: EMethod.POST,
    url: "/user/list/employee",
    version: API_VERSION.V1,
  },
  CREATE_CLIENT: {
    method: EMethod.POST,
    url: "/user/client",
    version: API_VERSION.V1,
  },
  GET_CLIENT_BASIC_INFO: {
    method: EMethod.GET,
    url: "/user/client/basic-information",
    version: API_VERSION.V1,
  },
  UPDATE_CLIENT_BASIC_INFO: {
    method: EMethod.PATCH,
    url: "/user/client/basic-information",
    version: API_VERSION.V1,
  },
  GET_CLIENT_POST: {
    method: EMethod.GET,
    url: "/user/client/post/list",
    version: API_VERSION.V1,
  },
  ADD_CLIENT_POST: {
    method: EMethod.POST,
    url: "/user/client/post",
    version: API_VERSION.V1,
  },
  DELETE_CLIENT: {
    method: EMethod.DEL,
    url: "/user/client",
    version: API_VERSION.V1,
  },
  // end of client
  GET_USER_GLOBAL: {
    method: EMethod.POST,
    url: "/user/global/get",
    version: API_VERSION.V1,
  },
  GET_GLOBAL_USER_FILTER: {
    method: EMethod.GET,
    url: "/user/global/filter",
    version: API_VERSION.V1,
  },
  UPDATE_EMPLOYEE_PASSWORD: {
    method: EMethod.PUT,
    url: "/user/employee/password",
    version: API_VERSION.V1,
  },

  // education
  GET_SCHOOOL_TYPE: {
    method: EMethod.GET,
    url: "/user/education/school-type",
    version: API_VERSION.V1,
  },
  GET_SCHOOOL: {
    method: EMethod.GET,
    url: "/user/education/school",
    version: API_VERSION.V1,
  },
};
